export const Footer = () => {
  return (
    <footer
      className="pt-16 mt-auto border-t border-white/5"
      data-testid="site-footer"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-6">
        <p
          className="font-mono-plex text-[10px] uppercase tracking-[0.28em] text-white/30"
          data-testid="footer-copyright"
        >
          © 2026 Our Local Stories LLC. All Rights Reserved.
        </p>

        <p
          className="font-mono-plex text-[10px] uppercase tracking-[0.28em] text-white/25"
          data-testid="footer-tagline"
        >
          Built for the road · Anchored in code
        </p>
      </div>
    </footer>
  );
};

export default Footer;
